import * as React from "react";
import { classNames } from "@features/utils/reactFunctions";
import * as elements from "@appStyles/_elements.module.scss";
import Checkbox from "@appComponents/Checkbox/Checkbox";

import * as style from "../../CelsiusClaimPageStyles.module.scss";

type Props = {
  handleImportFunds: () => void;
};

export const InitialState = ({ handleImportFunds }: Props) => {
  const [agreementChecked, setAgreementChecked] = React.useState(false);

  return (
    <>
      <h1 className={style.headerTitle}>Import Your Celsius Claim</h1>
      <p className={style.headerText} style={{ textAlign: "justify" }}>
        Bnk To The Future displays your claim by finding your full name in the
        public schedule of asset list. If you have a unique match your request
        will automatically be accepted. If there are multiple matches, we will
        ask you for more details so that we can find the exact match.
        <br />
        <br />
        <strong>IMPORTANT:</strong> This feature is for informational purposes
        only. There may be inaccuracies in the source data or the data import
        process. Under no circumstances is the importing of data anything more
        than a data import. No legal transfer of claim is being performed when
        the data is imported.
        <br />
        <br />
        If you choose to connect your Celsius claim information to your Bnk To
        The Future account, you will not be agreeing or committing to vote your
        Celsius claim in favor of a plan of reorganization or other transaction
        supported by Bnk To The Future or to otherwise support such a plan or
        transaction. Bnk To The Future is not now soliciting support for any
        such plan or transaction from Celsius creditors. Such a solicitation
        would only be made based on a Disclosure Statement which has been
        approved by the Bankruptcy Court as containing adequate information or
        another order of the Celsius Bankruptcy Court which expressly permits
        such solicitation.
      </p>

      <div className={style.checkbox}>
        <Checkbox
          checked={agreementChecked}
          onClick={() => setAgreementChecked((prev) => !prev)}
        >
          I understand that only the data of my claim will be displayed on the
          platform and that this feature is for informational purposes only.
        </Checkbox>
      </div>

      <button
        className={classNames(elements.btn, style.actionButton)}
        onClick={handleImportFunds}
        disabled={!agreementChecked}
      >
        Import my Celsius Claim
      </button>
      <div className={style.paddingBottom20} />
    </>
  );
};
